export const iconFontAwesomeEnergyGasPump = (
	<i className="fa-solid fa-gas-pump"></i>
);
